// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/nexus/integrations/integrations.actions.go

export const GET_TOKEN_FOR_INTEGRATION =
  "mondoo.integrations.IntegrationsManager.GetTokenForIntegration";
